import { IdNameList } from "../../../../api/services/common/models";
import { ChipOptionsDataType } from "../../../../components";

export const EditParticipantGenericAccountFormKey = {
  programEndDate: "programEndDate",
  timeZoneId: "timeZoneId",
  city: "city",
  languagePreference: "languagePreference",
  smsNotificationsCheckbox: "smsNotificationsCheckbox",
  emailNotificationsCheckbox: "emailNotificationsCheckbox",
  emailforNotifications: "emailforNotifications",
  platformDetails: "platformDetails",
  contactPreferences: "contactPreferences",
  sendEmailNotifications: "sendEmailNotifications",
} as const;

export interface EmailNotifications {
  email: string;
  isSelected: boolean;
  isPrimary?: boolean;
}

export interface ContactPreferences {
  smsNotifications: boolean;
  emailNotifications: boolean;
  emailforNotifications?: EmailNotifications[];
  emailIdforNotifications?: string;
  isTPSBlacklist?: boolean;
}

export interface LanguagePreference extends IdNameList {
  isSelected: boolean;
}

export interface LabeledValue {
  hasPermission: boolean;
  details: {
    label: string;
    value?:
      | string
      | string[]
      | LanguagePreference[]
      | ChipOptionsDataType[]
      | boolean;
    isEdit?: boolean;
    render?: () => JSX.Element;
  }[];
}

export interface ParticipantDetails {
  participantInformation: LabeledValue;
  programInformation: LabeledValue;
  platformDetails: LabeledValue;
  contactPreferences: LabeledValue;
}
